export default __webpack_public_path__ + "static/media/template_business-man__0006_21---ferdinandPut.fbf04618.png";